module.exports = __webpack_public_path__ + "static/img/28_pro.ec40451.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/28_pro.jpg
// module id = Vz6C
// module chunks = 0